import { render } from "./PermissionGroupItem.vue?vue&type=template&id=e1ebec42&ts=true"
import script from "./PermissionGroupItem.vue?vue&type=script&lang=ts"
export * from "./PermissionGroupItem.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__